import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useCompanyStore } from 'stores';
//constants
import { history, howWorks, team, aboutus } from './imagesAboutUs';
// components
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';
import TeamComponent from 'components/teamComponent';
import ContentElement from 'components/contentElement';
import HistoryComponent from 'components/historyComponent';
//styles
import '../../assets/css/staticPages.scss';

const AboutUs = () => {
  const { descripcion_pub, is_single_company } = useCompanyStore();
  const { t } = useTranslation('footer');
  const title = t('aboutus');

  return (
    <div className="content justify-content-center d-flex mainDiv">
      <div className="container-fluid mx-3">
        <Head description={descripcion_pub} title={title} noIndex={true} />
        <Row>
          <Col md={12}>
            <TitleWithLine text={t('aboutus')} />
          </Col>
        </Row>
        {is_single_company ? (
          <Row>
            <Col md={12}>
              <div dangerouslySetInnerHTML={{ __html: descripcion_pub }} />
            </Col>
          </Row>
        ) : (
          <>
            <Row>
              <Col md={{ span: 10, offset: 1 }}>
                <h2 className="page-subtitle mt-5 mb-4">{t('what_is')}</h2>
                <Row>
                  {aboutus.map((item) => (
                    <ContentElement
                      key={item.id}
                      image={item.image}
                      alt={item.alt}
                      text={t(`${item.text}`)}
                      numElements={aboutus.length}
                    />
                  ))}
                </Row>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 10, offset: 1 }}>
                <h2 className="text-center mt-5 mb-4">{t('how_it_works')}</h2>
                <Row>
                  {howWorks.map((item) => (
                    <ContentElement
                      key={item.id}
                      image={item.image}
                      alt={item.alt}
                      text={t(`${item.text}`)}
                      numElements={howWorks.length}
                    />
                  ))}
                </Row>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 10, offset: 1 }}>
                <h2 className="text-center mt-5 mb-4">{t('history')}</h2>
                <Row>
                  {history.map((item) => (
                    <HistoryComponent
                      key={item.id}
                      image={item.image}
                      year={item.year}
                      title={t(`${item.title}`)}
                      description={t(`${item.description}`)}
                      alt={item.alt}
                    />
                  ))}
                </Row>
              </Col>
            </Row>
            <Row>
              <Col md={{ span: 10, offset: 1 }}>
                <h2 className="text-center mt-5 mb-4">{t('libelista_team')}</h2>
                <Row>
                  {team.map((item) => (
                    <TeamComponent
                      key={item.id}
                      image={item.image}
                      name={item.name}
                      profession={t(`${item.profession}`)}
                      alt={item.alt}
                    />
                  ))}
                </Row>
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  );
};

export default AboutUs;
